import api, { MetadataEntity } from 'api'
import AppAction from 'components/AppAction/AppAction'
import AppTableAction from 'components/AppAction/AppTableAction'
import AppDialog from 'components/AppDialog'
import { AppGridHeard } from 'components/AppGridLayout/AppGridHeard'
import AppGridLayout from 'components/AppGridLayout/AppGridLayout'
import AppGridMenu from 'components/AppGridLayout/AppGridMenu'
import AppGridTabs from 'components/AppGridLayout/AppGridTabs'
import AppGridView from 'components/AppGridLayout/AppGridView'
import { AppTable } from 'components/AppTable'
import { AppGridSearch } from 'components/AppTableSearch/AppGridSearch'
import React, { Component } from 'react'
import EntityFormPage from './EntityFormPage'
interface DataTableProps {
	callBack?: (data: MetadataEntity) => void
}
// 数据表列表
export default class DataTable extends Component<DataTableProps> {
	state = { tableSearch: { systemCode: '00', name: '' } }
	// 查询
	onSearch = (filterData: any, data?: any) => {
		let tableSearch = { ...this.state.tableSearch, name: data.appGridCommonSearch || '' }
		this.refTable && this.refTable.current && this.refTable.current.queryGrid(tableSearch)
		this.setState({ tableSearch })
	}
	// 新增数据表
	addTableItem = () => {
		let metadataEntity: MetadataEntity = {
			application: '00',
			id: 0,
			metadataVersion: '0.1',
			name: '',
			primaryKey: '',
		}
		AppDialog.open(<EntityFormPage mode={1} metadataEntity={metadataEntity} afterSave={this.refreshTable} />, {
			title: '新增数据表',
			height: 310,
		})
	}
	// 编辑数据表
	editDataTable = (data: MetadataEntity) => {
		this.props.callBack && this.props.callBack(data)
	}
	// 刷新Tabe
	refreshTable = () => {
		this.refTable && this.refTable.current && this.refTable.current.refreshData()
	}
	refTable = React.createRef<AppTable>()
	render() {
		return (
			<AppGridLayout defaultViewId={-1}>
				<AppGridSearch
					commonSearchList={[{ dataType: 'string', field: 'name', label: '请输入数据表名称' }]}
					onSearch={this.onSearch}
				/>
				<AppGridHeard>
					<AppGridTabs></AppGridTabs>
					<AppGridMenu>
						<AppAction title="新增" type="primary" action={this.addTableItem}></AppAction>
					</AppGridMenu>
				</AppGridHeard>
				<AppGridView viewId={-1}>
					<AppTable
						api={api.modeling.entity.getPageList}
						data={this.state.tableSearch}
						ref={this.refTable}
						paging
					>
						<AppTable.ColIndex />
						<AppTable.Col title="中文名" align="center" field="displayName" width={200} />
						<AppTable.Col title="英文名" align="center" field="name" width={200} />
						<AppTable.Col title="状态" align="center" field="state" width={100} />
						<AppTable.Col title="修改人" align="center" field="modifiedBy" width={200} />
						<AppTable.ColDate title="修改时间" field="modifiedOn" width={150} />
						<AppTable.ColAction
							render={(data: MetadataEntity) => {
								return (
									<React.Fragment>
										<AppTableAction
											onClick={() => {
												this.editDataTable(data)
											}}
											label="编辑"
										/>
										<AppTableAction
											// onClick={() => this.deleteUser(user)}
											label="删除"
										/>
									</React.Fragment>
								)
							}}
						/>
					</AppTable>
				</AppGridView>
			</AppGridLayout>
		)
	}
}



// WEBPACK FOOTER //
// ./src/modules/modeling/entity/DataTable.tsx